import { defineComponent as _defineComponent } from 'vue'
import '@/assets/css/global/google_fonts/roboto.css'
import '@/assets/css/global/materialdesign/icons/materialdesignicons.min.css'

import {
  onMounted,
  Ref,
  ref,
  unref,
} from "vue";

import {
  View,
} from "@/Enums";

import {
  getToken,
  hasActiveToken,
  OperationResults,
  setToken,
} from "@/scripts/Common";

import {
  PolicyConstants,
} from "@/authorization/constants/PolicyConstants";

import {
  PermissionConstants,
} from "@/authorization/constants/PermissionConstants";

import Login from "@/components/Login.vue";

import Start from "@/components/Start.vue";

import Menu from "@/components/Menu.vue";

import ProfiControlUserManagement from "@/components/ProfiControlUserManagement.vue";

import {
  CustomerManagement,
  CustomerCoreData,
} from "@/components/customers";

import Report from "@/components/reports/Report.vue";

import ChangePassword from "@/components/ChangePassword.vue";

import {
  CustomerBankTransfers,
  IssuerBankTransfers,
} from "@/components/bankTransfers";

import {
  RoleManager,
} from "@/authorization/RoleManager";

import {
  AdministerIssuerCards,
  AdministerIssuerWebcharges,
  IssuerCoreData,
  IssuerManagement,
  IssuerReports,
} from "@/components/issuers";

import {
  GratificationSettings,
  SepaSettings,
  VatSettings,
  WebchargeSettings
} from "@/components/settings";

import {
  AdministerCards,
} from "@/components/cards";

import {
  ErrorDialog,
  ErrorItemDialog,
} from "@/components/dialogs";

import {
  PasswordReset,
} from "@/components/administrations";

import OperatorManagement from "@/components/operator/OperatorManagement.vue";
import AdminImports from '@/components/administrations/Import/AdminImports.vue';
import CardUserManagement from "@/components/cardUsers/CardUserManagement.vue";
import CardUserCoreData from "@/components/cardUsers/CardUserCoreData.vue";
import IssuerUserManagement from "@/components/issuers/IssuerUserManagement.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


const token = ref<string>("");

const currentView = ref<View>(View.Login);

const permissionMap = ref<Map<string, Map<string, boolean>>>(new Map());
const customerEditRights = ref<boolean>(false);
const userEditRights = ref<boolean>(false);
const sepaEditRights = ref<boolean>(false);
const sepaDownloadRights = ref<boolean>(false);
const systemAdministrationEditRights = ref<boolean>(false);
const systemAdministrationCertificateRights = ref<boolean>(false);
const reportEditRights = ref<boolean>(false);
const reportDownloadRights = ref<boolean>(false);
const reportReadRights = ref<boolean>(false);

const issuerId = ref<number>(0);
const userId = ref<number>(0);
const customerId = ref<number>(0);
const startInCreationMode = ref<boolean>(false);

const fetchError = ref<any>();
const itemResults = ref<OperationResults<any>>();

const loggedIn = (jwt: string) => {
  token.value = jwt;
  setToken(jwt);
  currentView.value = View.Start;
}
const onHandleFetchError = ({error}: { error: any }) => {
  fetchError.value = error;
};

const onHandleItemError = ({response}: { response: OperationResults<any> }) => {
  itemResults.value = response;
}

const authorize = (permissions: Map<string, Map<string, boolean>>) => {
  permissionMap.value = permissions;
  customerEditRights.value = permissionMap.value
      .get(PolicyConstants.CUSTOMER_DATA_POLICIES)
      ?.get(PermissionConstants.EDIT)
    ?? false;

  userEditRights.value = permissionMap.value
      .get(PolicyConstants.USER_DATA_POLICIES)
      ?.get(PermissionConstants.EDIT)
    ?? false;

  sepaEditRights.value = permissionMap.value
      .get(PolicyConstants.SEPA_POLICIES)
      ?.get(PermissionConstants.EDIT)
    ?? false;

  sepaDownloadRights.value = permissionMap.value
      .get(PolicyConstants.SEPA_POLICIES)
      ?.get(PermissionConstants.DOWNLOAD)
    ?? false;

  systemAdministrationEditRights.value = permissionMap.value
      .get(PolicyConstants.SYSTEM_ADMINISTRATION_POLICIES)
      ?.get(PermissionConstants.EDIT)
    ?? false;

  systemAdministrationCertificateRights.value = permissionMap.value
      .get(PolicyConstants.SYSTEM_ADMINISTRATION_POLICIES)
      ?.get(PermissionConstants.MANAGE_CERTIFICATES)
    ?? false;

  reportEditRights.value = permissionMap.value
      .get(PolicyConstants.SALES_REPORT_POLICIES)
      ?.get(PermissionConstants.EDIT)
    ?? false;
  reportDownloadRights.value = permissionMap.value
      .get(PolicyConstants.SALES_REPORT_POLICIES)
      ?.get(PermissionConstants.DOWNLOAD)
    ?? false;

  reportReadRights.value = permissionMap.value
      .get(PolicyConstants.SALES_REPORT_POLICIES)
      ?.get(PermissionConstants.READ)
    ?? false;
}

const onHandleMenuItemClick = (view: View) => {
  currentView.value = view;
  startInCreationMode.value = false;
}

const setView = (view: View) => {
  currentView.value = view;
}

const onHandleCreateIssuer = (view: View) => startViewInCreationMode(view, issuerId);

const onHandleCreateUser = (value: {
  id: number
}, view: View) => startViewInCreationMode(view, userId);

const onHandleCreateCustomer = (view: View) => startViewInCreationMode(view, customerId);

const startViewInCreationMode = (view: View, idField: Ref<number>) => {
  idField.value = 0;
  startInCreationMode.value = true;
  setView(view);
}

const onHandleErrorDialogCancelOrConfirm = () => {
  fetchError.value = undefined;
}

const onHandleErrorItemDialogCancelOrConfirm = () => {
  itemResults.value = undefined;
}

onMounted(async () => {
  if (!hasActiveToken()) {
    setView(View.Login);
    return;
  }

  setView(View.Start);
  token.value = getToken();
  permissionMap.value = RoleManager.GeneratePermissionMap(unref(token));
  authorize(unref(permissionMap));
});


return { __sfc: true,token, currentView, permissionMap, customerEditRights, userEditRights, sepaEditRights, sepaDownloadRights, systemAdministrationEditRights, systemAdministrationCertificateRights, reportEditRights, reportDownloadRights, reportReadRights, issuerId, userId, customerId, startInCreationMode, fetchError, itemResults, loggedIn, onHandleFetchError, onHandleItemError, authorize, onHandleMenuItemClick, setView, onHandleCreateIssuer, onHandleCreateUser, onHandleCreateCustomer, startViewInCreationMode, onHandleErrorDialogCancelOrConfirm, onHandleErrorItemDialogCancelOrConfirm, View, Login, Start, Menu, ProfiControlUserManagement, CustomerManagement, CustomerCoreData, Report, ChangePassword, CustomerBankTransfers, IssuerBankTransfers, AdministerIssuerCards, AdministerIssuerWebcharges, IssuerCoreData, IssuerManagement, IssuerReports, GratificationSettings, SepaSettings, VatSettings, WebchargeSettings, AdministerCards, ErrorDialog, ErrorItemDialog, PasswordReset, OperatorManagement, AdminImports, CardUserManagement, CardUserCoreData, IssuerUserManagement }
}

})